import { useState, useEffect } from 'react';
import { useDebouncedValue } from './use-debounced-value';

interface UseSearchProps {
  debounceDelay?: number;
}

export const useSearch = ({ debounceDelay = 300 }: UseSearchProps = {}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  const debouncedSearch = useDebouncedValue(searchTerm, debounceDelay);

  useEffect(() => {
    setDebouncedSearchTerm(value =>
      value !== debouncedSearch ? debouncedSearch : value
    );
  }, [debouncedSearch]);

  const clearSearch = () => {
    setSearchTerm('');
    setDebouncedSearchTerm('');
  };

  return {
    debouncedSearchTerm,
    searchTerm,
    onSearch: setSearchTerm,
    clearSearch,
  };
};
